/*
 *
 *  actions
 *
 */

import {
  LOAD_EXPENSES_LIST,
  LOAD_EXPENSES_LIST_SUCCESS,
  LOAD_EXPENSES_LIST_ERROR,
  LOAD_EXPENSES_ITEMS_LIST,
  LOAD_EXPENSES_ITEMS_LIST_SUCCESS,
  LOAD_EXPENSES_ITEMS_LIST_ERROR,
  LOAD_EXPENSES_CATEGORIES_LIST,
  LOAD_EXPENSES_CATEGORIES_LIST_SUCCESS,
  LOAD_EXPENSES_CATEGORIES_LIST_ERROR,
  CREATE_EXPENSES_LIST,
  CREATE_EXPENSES_LIST_SUCCESS,
  CREATE_EXPENSES_LIST_ERROR,
  UPDATE_EXPENSES_LIST,
  UPDATE_EXPENSES_LIST_SUCCESS,
  UPDATE_EXPENSES_LIST_ERROR,
  DELETE_EXPENSES_LIST,
  DELETE_EXPENSES_LIST_SUCCESS,
  DELETE_EXPENSES_LIST_ERROR,
  LOAD_EXPENSES_LIST_RECORDS_META_DATA,
  LOAD_EXPENSES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_EXPENSES_LIST_RECORDS_META_DATA_ERROR,
  LOAD_EXPENSE_REPORT_LIST,
  LOAD_EXPENSE_REPORT_LIST_SUCCESS,
  LOAD_EXPENSE_REPORT_LIST_ERROR,
  LOAD_CASH_BANK_REPORT_LIST,
  LOAD_CASH_BANK_REPORT_LIST_SUCCESS,
  LOAD_CASH_BANK_REPORT_LIST_ERROR,
  LOAD_PREFIX_SETTINGS_LIST,
  LOAD_PREFIX_SETTINGS_LIST_SUCCESS,
  LOAD_PREFIX_SETTINGS_LIST_ERROR,

  
  LOAD_FINANCIAL_YEAR_LIST,
  LOAD_FINANCIAL_YEAR_LIST_SUCCESS,
  LOAD_FINANCIAL_YEAR_LIST_ERROR,
} from "./constants";

// load payment in
export function loadExpensesList(paymentDetails) {
  return {
    type: LOAD_EXPENSES_LIST,
    paymentDetails,
  };
}

export function loadExpensesListSuccess(expenses_list, success) {
  return {
    type: LOAD_EXPENSES_LIST_SUCCESS,
    expenses_list,
    success,
  };
}

export function loadExpensesListError(error) {
  return {
    type: LOAD_EXPENSES_LIST_ERROR,
    error,
  };
}

// load prefix setting
export function loadPrefixSettingsList(paymentDetails) {
  return {
    type: LOAD_PREFIX_SETTINGS_LIST,
    paymentDetails,
  };
}

export function loadPrefixSettingsListSuccess(prefix_settings_list, success) {
  return {
    type: LOAD_PREFIX_SETTINGS_LIST_SUCCESS,
    prefix_settings_list,
    success,
  };
}

export function loadPrefixSettingsListError(error) {
  return {
    type: LOAD_PREFIX_SETTINGS_LIST_ERROR,
    error,
  };
}

// load financial year setting
export function loadFinancialYearList(paymentDetails) {
  return {
    type: LOAD_FINANCIAL_YEAR_LIST,
    paymentDetails,
  };
}

export function loadFinancialYearListSuccess(financial_year_list, success) {
  return {
    type: LOAD_FINANCIAL_YEAR_LIST_SUCCESS,
    financial_year_list,
    success,
  };
}

export function loadFinancialYearListError(error) {
  return {
    type: LOAD_FINANCIAL_YEAR_LIST_ERROR,
    error,
  };
}

// load payment in
export function loadExpensesItemList(paymentDetails) {
  return {
    type: LOAD_EXPENSES_ITEMS_LIST,
    paymentDetails,
  };
}

export function loadExpensesItemListSuccess(expenses_item_list, success) {
  return {
    type: LOAD_EXPENSES_ITEMS_LIST_SUCCESS,
    expenses_item_list,
    success,
  };
}

export function loadExpensesItemListError(error) {
  return {
    type: LOAD_EXPENSES_ITEMS_LIST_ERROR,
    error,
  };
}
// load parties
export function loadExpensesCategories(paymentDetails) {
  return {
    type: LOAD_EXPENSES_CATEGORIES_LIST,
    paymentDetails,
  };
}

export function loadExpensesCategoriesSuccess(
  expenses_categories_list,
  success
) {
  return {
    type: LOAD_EXPENSES_CATEGORIES_LIST_SUCCESS,
    expenses_categories_list,
    success,
  };
}

export function loadExpensesCategoriesError(error) {
  return {
    type: LOAD_EXPENSES_CATEGORIES_LIST_ERROR,
    error,
  };
}

// load expenses report
export function loadExpensesReportList(paymentDetails) {
  return {
    type: LOAD_EXPENSE_REPORT_LIST,
    paymentDetails,
  };
}

export function loadExpensesReportListSuccess(expenses_report_list, success) {
  return {
    type: LOAD_EXPENSE_REPORT_LIST_SUCCESS,
    expenses_report_list,
    success,
  };
}

export function loadExpensesReportListError(error) {
  return {
    type: LOAD_EXPENSE_REPORT_LIST_ERROR,
    error,
  };
}
// load parties
export function loadCashBankReportList(paymentDetails) {
  return {
    type: LOAD_CASH_BANK_REPORT_LIST,
    paymentDetails,
  };
}

export function loadCashBankReportListSuccess(
  cash_bank_reports,
  success
) {
  return {
    type: LOAD_CASH_BANK_REPORT_LIST_SUCCESS,
    cash_bank_reports,
    success,
  };
}

export function loadCashBankReportListError(error) {
  return {
    type: LOAD_CASH_BANK_REPORT_LIST_ERROR,
    error,
  };
}

//payment in report

// load payment in
export function loadAccountTransactionList(paymentDetails) {
  return {
    type: LOAD_EXPENSES_CATEGORIES_LIST,
    paymentDetails,
  };
}

export function loadAccountTransactionListSuccess(
  account_transaction_list,
  success
) {
  return {
    type: LOAD_EXPENSES_CATEGORIES_LIST_SUCCESS,
    account_transaction_list,
    success,
  };
}

export function loadAccountTransactionListError(error) {
  return {
    type: LOAD_EXPENSES_CATEGORIES_LIST_ERROR,
    error,
  };
}


// load parties
export function createExpensesList(paymentDetails) {
  return {
    type: CREATE_EXPENSES_LIST,
    paymentDetails,
  };
}

export function createExpensesListSuccess(paymentDetails, success) {
  return {
    type: CREATE_EXPENSES_LIST_SUCCESS,
    paymentDetails,
    success,
  };
}

export function createExpensesListError(error) {
  return {
    type: CREATE_EXPENSES_LIST_ERROR,
    error,
  };
}
// load parties
export function updateExpensesList(paymentDetails) {
  return {
    type: UPDATE_EXPENSES_LIST,
    paymentDetails,
  };
}

export function updateExpensesListSuccess(paymentDetails, success) {
  return {
    type: UPDATE_EXPENSES_LIST_SUCCESS,
    paymentDetails,
    success,
  };
}

export function updateExpensesListError(error) {
  return {
    type: UPDATE_EXPENSES_LIST_ERROR,
    error,
  };
}
// load parties
export function deleteExpensesList(paymentDetails) {
  return {
    type: DELETE_EXPENSES_LIST,
    paymentDetails,
  };
}

export function deleteExpensesListSuccess(paymentDetails, success) {
  return {
    type: DELETE_EXPENSES_LIST_SUCCESS,
    paymentDetails,
    success,
  };
}

export function deleteExpensesListError(error) {
  return {
    type: DELETE_EXPENSES_LIST_ERROR,
    error,
  };
}

export function loadExpensesListRecordsMetaData() {
  return {
    type: LOAD_EXPENSES_LIST_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadExpensesListRecordsMetaDataSuccess(expenseMetaData) {
  return {
    type: LOAD_EXPENSES_LIST_RECORDS_META_DATA_SUCCESS,
    expenseMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadExpensesListRecordsMetaDataError(error) {
  return {
    type: LOAD_EXPENSES_LIST_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadExpensesList,
  loadExpensesListSuccess,
  loadExpensesListError,

  loadPrefixSettingsList,
  loadPrefixSettingsListSuccess,
  loadPrefixSettingsListError,

  loadFinancialYearList,
  loadFinancialYearListSuccess,
  loadFinancialYearListError,

  loadAccountTransactionList,
  loadAccountTransactionListSuccess,
  loadAccountTransactionListError,

  loadExpensesItemList,
  loadExpensesItemListSuccess,
  loadExpensesItemListError,

  loadExpensesReportList,
  loadExpensesReportListSuccess,
  loadExpensesReportListError,

  loadCashBankReportList,
  loadCashBankReportListSuccess,
  loadCashBankReportListError,

  createExpensesList,
  createExpensesListSuccess,
  createExpensesListError,

  updateExpensesList,
  updateExpensesListSuccess,
  updateExpensesListError,

  deleteExpensesList,
  deleteExpensesListSuccess,
  deleteExpensesListError,

  loadExpensesListRecordsMetaData,
  loadExpensesListRecordsMetaDataSuccess,
  loadExpensesListRecordsMetaDataError,
  loadExpensesCategories,
  loadExpensesCategoriesSuccess,
  loadExpensesCategoriesError,
};

export default actions;
